import React, { Fragment, useCallback, useState } from 'react';
import { Field } from 'react-final-form';
import formatString from 'format-string-by-pattern';

import './styles.css';

function Input({ 
  name,
  label, 
  error,
  onMask,
  onChange,
  toForm = true,
  loading = false,
  onChangeValue,
  ...rest
}) {
  const [value, setValue] = useState('');

  const handleChange = useCallback((event) => {
      const { value: val } = event.target;

      setValue(val);

      if (onChangeValue) {
        onChangeValue(val);
      }

      if (onChange) {
        onChange(event);
      }
    },
    [onChange, onChangeValue],
  );

  const handleParse = useCallback((val) => {
      if (onMask) {
        return onMask(val);
      }

      return val;
    },
    [onMask],
  );

  if (loading) {
    return (
      <div className="input--skeleton">
        <div className="input__label" />
        <div />
      </div>
    );
  }

  return (
    <div className="input">
      {label && (
        <label htmlFor={name} className="input__label">{label}</label>
      )}
      {toForm ? (
        <Field name={name} parse={handleParse}>
          {({ input, meta }) => (
            <Fragment>
              <input
                {...input}
                {...rest}
                id={name}
                className={
                  `input__field${
                    (meta['error'] || meta['submitError']) && meta['touched'] 
                      ? ' error' 
                      : ''
                  }`
                  
                }
              />
              {(meta.error || meta.submitError) && meta.touched && (
                <span className="input__error">
                  {meta.error || meta.submitError}
                </span>
              )}
            </Fragment>
          )}
        </Field>
      ) : (
        <Fragment>
          <input name={name} value={value} onChange={handleChange} {...rest} />
          {!!error && <span className="input__error">{error}</span>}      
        </Fragment>
      )}
    </div>
  );
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/ui/Input/index.js